import type { EnvironmentId } from "@cmmd-forge/contracts";

import { ensureDesktopRuntimeEnvironmentApi } from "~/lib/ensureDesktopRuntimeEnvironmentApi";
import type { SidebarProjectSnapshot } from "./SidebarProjectItem";

type EnsureDesktopRuntime = typeof ensureDesktopRuntimeEnvironmentApi;

export function requiresDesktopRuntimeAttach(project: SidebarProjectSnapshot): boolean {
  return (
    project.environmentPresence === "remote-only" &&
    project.source.actionAuthority === "runtime" &&
    project.source.executionRuntime === "desktop-local"
  );
}

export async function attachDesktopRuntimeThenCreateThread(input: {
  readonly environmentId: EnvironmentId;
  readonly primaryEnvironmentId: EnvironmentId | null;
  readonly label: string;
  readonly createThread: () => Promise<unknown>;
  readonly closeSidebar: () => void;
  readonly ensureRuntime?: EnsureDesktopRuntime;
}): Promise<void> {
  const ensureRuntime = input.ensureRuntime ?? ensureDesktopRuntimeEnvironmentApi;
  await ensureRuntime({
    environmentId: input.environmentId,
    primaryEnvironmentId: input.primaryEnvironmentId,
    label: input.label,
  });
  await input.createThread();
  input.closeSidebar();
}
